class ResultInstance<T, K> {
	constructor(
		public readonly ok: T,
		public readonly err: K,
	) {
		// Empty
	}
}

window.Ok = <T, _K>(value: T) => {
	return new ResultInstance(value, null);
};

window.Err = <_T, K>(value: K) => {
	return new ResultInstance(null, value);
};
